import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ProductService } from '../../../services/product.service';
import { ErrorMessageService } from '../../../../shared/error-message.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';
import { CreditLineService } from '../../../services/credit-line.service';

@Component({
    selector: 'app-product-info',
    templateUrl: './product-info.component.html',
    styleUrls: ['./product-info.component.scss']
})
export class ProductInfoComponent implements OnInit {

    @Input() product: any = null;
    @Input() canEdit: boolean = false;
    @Input() loan: any = null;
    @Input() resource: string = 'credit_line';
    @Output() productChanged = new EventEmitter<any>();

    products: any[] = [];
    selectedProductId: number = null;
    isEditing: boolean = false;

    constructor(
        private productService: ProductService,
        private creditLine: CreditLineService,
        private errorMessageService: ErrorMessageService,
        private http: HttpClient
    ) { }

    ngOnInit() {
        if(this.canEdit) {
            this.loadProducts();
        }
    }

    loadProducts() {
        this.productService.getProducts().subscribe(
            (products: any) => {
                this.products = products;
            }
        );
    }

    saveProduct() {
        if (this.selectedProductId && this.loan && this.loan.id) {
            this.creditLine.changeLoanProduct(this.loan.id, this.selectedProductId).subscribe(
                (response: any) => {
                    this.productService.get(this.selectedProductId).subscribe(
                        (product: any) => {
                            this.product = product;
                            this.productChanged.emit(product);
                        }
                    );
                    this.errorMessageService.showSuccess('El producto ha sido cambiado');
                    this.isEditing = false;
                    this.selectedProductId = null;
                },
                error => {
                    this.errorMessageService.showError('El producto no se ha podido cambiar por un error');
                }
            );
        }
    }

}
